import React, { useEffect, useState } from "react";
import {
  BomInstallationType,
  BomTotalType,
} from "../../../../commonTypes/billOfMaterial";
import {
  AddIconColor,
  AddIconWhite,
  RedDeleteIcon,
} from "../../../../assets/images";
type AppProps = {
  total: {
    input: BomTotalType;
    output: BomTotalType;
    totalAdditionalCost?: number;
  };
  data: BomInstallationType[];
  templateId?: string;
  addMoreData: (type: string) => void;
  handleEdit: (id: number) => void;
  setBomInstallationData: React.Dispatch<
    React.SetStateAction<BomInstallationType[]>
  >;
  deleteData: (type: string, id: number) => void;
  handleInstallationChange: (e: any, index: number) => void;
};
const BomInstallationCost = ({
  data,
  addMoreData,
  total,
  templateId,
  handleInstallationChange,
  setBomInstallationData,
  deleteData,
}: AppProps) => {
  const [buttonColor, setButtonColor] = useState<boolean>(false);

  useEffect(() => {
    let newInstallationData = data?.map((item: any) => {
      if (total?.input?.amount && item?.percentage) {
        return {
          ...item,
          price: ((+total?.input?.amount * +item?.percentage) / 100)
            ?.toFixed(2)
            ?.toString(),
        };
      } else {
        return item;
      }
    });
    setBomInstallationData([...newInstallationData]);
  }, [total?.input?.amount]);

  return (
    <div className="bom-responsive">
      <div className="bomInstallation table-responsive">
        <table className="table">
          <thead>
            {/* <td> */}
            <th style={{ backgroundColor: "white" }}>
              <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                <div className="addtionalHeader">ADDITIONAL COST</div>

                <div>
                  {!templateId ? (
                    <button
                      className="btn btn-sm btn-outline ml-2 mr-1"
                      onMouseOver={() => setButtonColor(true)}
                      onMouseOut={() => setButtonColor(false)}
                      onClick={() => addMoreData("installationCost")}
                    >
                      <img
                        className="btn-outline"
                        src={buttonColor ? AddIconWhite : AddIconColor}
                        alt="add_icon"
                      />
                      Add
                    </button>
                  ) : null}
                </div>
              </div>
            </th>
            <th
              style={{ backgroundColor: "white" }}
              className="addtionalHeader"
            >
              %
            </th>
            <th
              style={{ backgroundColor: "white" }}
              className="addtionalHeader"
            >
              AMOUNT
            </th>
          </thead>
          <tbody>
            {data?.map((item: BomInstallationType, index: number) => {
              return (
                <tr>
                  <td style={{ width: "65%" }}>
                    <input
                      value={item?.itemName ? item?.itemName : ""}
                      name="itemName"
                      disabled={!!templateId}
                      onChange={(e: any) => handleInstallationChange(e, index)}
                      type="text"
                      width={10}
                      className={"form-control"}
                    />
                  </td>

                  <td>
                    <input
                      value={item?.percentage ? item?.percentage : ""}
                      name="percentage"
                      style={{ width: "60px" }}
                      onChange={(e: any) => handleInstallationChange(e, index)}
                      type="number"
                      disabled={!item?.itemName || !!templateId}
                      onWheel={(event) => event.currentTarget.blur()}
                      className={"form-control"}
                    />
                  </td>

                  <td className="installation-amount">
                    <input
                      value={item?.price ? item?.price : ""}
                      name="price"
                      disabled={!item?.itemName || !!templateId}
                      onChange={(e: any) => handleInstallationChange(e, index)}
                      onWheel={(event) => event.currentTarget.blur()}
                      type="number"
                      className={"form-control"}
                    />

                    {!templateId ? (
                      <span
                        className="pointer pl-1"
                        onClick={() => deleteData("installationCost", index)}
                      >
                        <img width={20} src={RedDeleteIcon} alt="error" />
                      </span>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BomInstallationCost;
